require( './select.js' );
require( './select.css' );